import { PropsWithChildren, ReactNode, useState } from 'react'
import { mdiTrashCanOutline } from '@mdi/js'

import { SpinnerCentered } from 'components/Loader'
import ConfirmDeleteModal from './ConfirmDeleteModal'
import { DeleteIcon, DeleteIconWrapper, DeleteLinkButton } from './styles'

interface DeleteButtonCellProps {
  handleConfirm: () => void
  title: ReactNode
  disabled?: boolean
  label?: string
}

export function DeleteButtonCell({
  children,
  handleConfirm,
  title,
  disabled,
  label = '',
}: PropsWithChildren<DeleteButtonCellProps>) {
  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] =
    useState(false)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <>
      {isLoading && <SpinnerCentered size="24" />}
      {isConfirmDeleteModalOpen && (
        <ConfirmDeleteModal
          isOpen
          handleDiscard={() => setIsConfirmDeleteModalOpen(false)}
          handleConfirm={async () => {
            setIsConfirmDeleteModalOpen(false)
            setIsLoading(true)
            await handleConfirm()
            setIsLoading(false)
          }}
          title={title}
        >
          {children}
        </ConfirmDeleteModal>
      )}
      {!isLoading && (
        <DeleteLinkButton
          onClick={() => setIsConfirmDeleteModalOpen(true)}
          disabled={disabled}
        >
          <DeleteIconWrapper>
            <DeleteIcon
              path={mdiTrashCanOutline}
              size={1}
              disabled={disabled}
            />
            {label}
          </DeleteIconWrapper>
        </DeleteLinkButton>
      )}
    </>
  )
}
